import {
  REGISTER_MOBILE_NUMBER,
  SHOW_SNACKBAR,
  GET_LOCATION_POSITION,
  IS_PAGE_EDIT,
  GET_STATE_NAME,
  GET_CITY_NAME,
  IS_LOADING,
  GET_CURRENT_PAGE,
  GET_TOTAL_COUNT,
  GET_DURATION,
  VIEW_STATUS_BUTTON,
  CLEAR_STATE_PAGE,
  GET_CLIENT_LIST,
  GET_MONTH_YEAR,
  GET_PROVIDER_CHAIN,
  GET_PROVIDER_BASED_ON_CHAIN,
  HISTORY_COUNT_ROW
} from "../../Utils/types";

const initialState = {
  getRegisterMobileNumber: "",
  snackbar: {
    message: "",
    open: false,
    type: "",
    time:""
  },
  getLocation: {
    providerLatitude: 0,
    providerLongitude: 0,
  },
  isPageEdit: false,
  getAllState: [],
  getAllCity: [],
  isLoading: false,
  getCurrentPage: 1,
  getTotalCount: null,
  getTotalHistoryRow:null,
  getDuration: "",
  viewStatusButton: null,
  clearStatePage: null,
  getClientList:[],
  getMonthYear:[],
  getProviderChains:[],
  getProviderBaseOnChains:[]

};

export default (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_MOBILE_NUMBER:
      return {
        ...state,
        getRegisterMobileNumber: action.payload,
      };
    case SHOW_SNACKBAR:
      return {
        ...state,
        snackbar: {
          message: action.payload.message,
          open: action.payload.open,
          type: action.payload.type,
          time:action.payload.time
        },
      };
    case GET_LOCATION_POSITION:
      return {
        ...state,
        getLocation: {
          providerLatitude: action.payload.providerLatitude,
          providerLongitude: action.payload.providerLongitude,
        },
      };
    case IS_PAGE_EDIT:
      return {
        ...state,
        isPageEdit: action.payload,
      };
    case GET_STATE_NAME:
      return {
        ...state,
        getAllState: action.payload,
      };
    case GET_CITY_NAME:
      return {
        ...state,
        getAllCity: action.payload,
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case GET_CURRENT_PAGE:
      return {
        ...state,
        getCurrentPage: action.payload,
      };
    case GET_TOTAL_COUNT:
      return {
        ...state,
        getTotalCount: action.payload,
      };
    case HISTORY_COUNT_ROW:
      return {
        ...state,
        getTotalHistoryRow: action.payload,
      };
    case GET_DURATION:
      return {
        ...state,
        getDuration: action.payload,
      };
    case VIEW_STATUS_BUTTON:
      return {
        ...state,
        viewStatusButton: action.payload,
      };
    case CLEAR_STATE_PAGE:
      return {
        ...state,
        clearStatePage: action.payload,
      };
    case GET_CLIENT_LIST:
      return {
        ...state,
        getClientList: action.payload,
      };
    case GET_MONTH_YEAR:
      return {
        ...state,
        getMonthYear: action.payload,
      };
    case GET_PROVIDER_CHAIN:
      return {
        ...state,
        getProviderChains: action.payload,
      };
    case GET_PROVIDER_BASED_ON_CHAIN:
      return {
        ...state,
        getProviderBaseOnChains: action.payload,
      };
    default:
      return state;
  }
};
